import {Switch} from '@material-ui/core';

export default function SwitchInput(props) {
  return <Switch disableRipple {...props} />;
}
